var map = {
	"./7z.svg": 53104,
	"./aac.svg": 41592,
	"./ai.svg": 37329,
	"./archive.svg": 88107,
	"./arj.svg": 49676,
	"./audio.svg": 26407,
	"./avi.svg": 48675,
	"./css.svg": 25212,
	"./csv.svg": 85217,
	"./dbf.svg": 69785,
	"./doc.svg": 39451,
	"./dwg.svg": 3663,
	"./exe.svg": 42993,
	"./fla.svg": 73746,
	"./flac.svg": 59837,
	"./gif.svg": 57655,
	"./html.svg": 65612,
	"./iso.svg": 23614,
	"./jpg.svg": 39284,
	"./js.svg": 25930,
	"./json.svg": 66261,
	"./mdf.svg": 5542,
	"./mp2.svg": 72190,
	"./mp3.svg": 34767,
	"./mp4.svg": 33648,
	"./mxf.svg": 69626,
	"./nrg.svg": 38498,
	"./pdf.svg": 81115,
	"./png.svg": 55720,
	"./ppt.svg": 69629,
	"./psd.svg": 82948,
	"./rar.svg": 57602,
	"./rtf.svg": 7513,
	"./svg.svg": 94887,
	"./text.svg": 41558,
	"./tiff.svg": 95282,
	"./txt.svg": 84073,
	"./unknown.svg": 45871,
	"./video.svg": 37864,
	"./wav.svg": 2175,
	"./wma.svg": 29036,
	"./xls.svg": 38678,
	"./xml.svg": 6430,
	"./zip.svg": 48640
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27341;